"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = Dropdown;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Dropdown(_ref) {
  var label = _ref.label,
      errorText = _ref.errorText,
      options = _ref.options,
      value = _ref.value,
      _onChange = _ref.onChange,
      multiple = _ref.multiple,
      FormControlProps = _ref.FormControlProps,
      InputLabelProps = _ref.InputLabelProps,
      SelectProps = _ref.SelectProps,
      FormHelperTextProps = _ref.FormHelperTextProps,
      MenuItemProps = _ref.MenuItemProps,
      variant = _ref.variant;
  return /*#__PURE__*/_react["default"].createElement(_material.FormControl, _extends({
    error: Boolean(errorText),
    fullWidth: true,
    variant: variant
  }, FormControlProps), label && /*#__PURE__*/_react["default"].createElement(_material.InputLabel, InputLabelProps, label), /*#__PURE__*/_react["default"].createElement(_material.Select, _extends({
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    multiple: multiple,
    variant: FormControlProps.variant || variant // this is here to automattically pass on the FormControl variant, if provided, since the Select default has changed to Outlined

  }, SelectProps), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, _extends({
      key: option.value,
      value: option.value
    }, MenuItemProps, option.props), option.display || option.value);
  })), errorText && /*#__PURE__*/_react["default"].createElement(_material.FormHelperText, FormHelperTextProps, errorText));
}

Dropdown.propTypes = {
  label: _propTypes["default"].string,
  errorText: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
    display: _propTypes["default"].node,
    props: _propTypes["default"].object
  })).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  multiple: _propTypes["default"].bool,
  FormControlProps: _propTypes["default"].object,
  InputLabelProps: _propTypes["default"].object,
  SelectProps: _propTypes["default"].object,
  FormHelperTextProps: _propTypes["default"].object,
  MenuItemProps: _propTypes["default"].object,
  variant: _propTypes["default"].string
};
Dropdown.defaultProps = {
  multiple: false,
  FormControlProps: {},
  InputLabelProps: {},
  SelectProps: {},
  variant: 'standard'
};
var _default = Dropdown;
exports["default"] = _default;